<spot-drop-modal
  [opened]="opened"
  (closed)="opened = false"
  class="op-baseline-modal"
>
  <button
    slot="trigger"
    type="button"
    class="button"
    [class.-active]="opened"
    (click)="toggleOpen()"
    [title]="text.toggle_title"
    data-test-selector="baseline-button"
  >
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" class="button--icon">
      <path d="M6 1.5h4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <path d="M8 3v1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
      <circle cx="8" cy="9" r="5.5" stroke="currentColor" stroke-width="1.4"/>
      <path d="M8 9V6.2" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
    </svg>
    {{ text.toggle_title }}
  
    <span class="spot-icon spot-icon_dropdown"></span>
  </button>
  <op-baseline
    [visible]="opened"
    [showActionBar]="true"
    slot="body"
    (submitted)="opened = false"
  ></op-baseline>
</spot-drop-modal>
